export const tableHeader = (t) => [
  {
    id: 'name',
    type: 'text',
    value: t('processes.show.dataTable.name'),
  },
  {
    id: 'storage',
    type: 'text',
    value: t('processes.show.dataTable.storage'),
  },
  {
    id: 'category',
    type: 'text',
    value: t('processes.show.dataTable.category'),
  },
  {
    id: 'dataSource',
    type: 'text',
    value: t('processes.show.dataTable.origin'),
  },
  {
    id: 'holderProfile',
    type: 'text',
    value: t('processes.show.dataTable.holder'),
  },
  {
    id: 'retentionPeriod',
    type: 'text',
    value: t('processes.show.dataTable.retention'),
  },
  {
    id: 'action',
    type: 'actions-datamapping',
    value: t('processes.table.actions'),
  },
];
